import { createContext, useContext } from 'react';
export const MonetizationContext = createContext({ premiumGateEnabled: false });
export const useMonetization = () => useContext(MonetizationContext);
